import React from 'react';
import { close, mic, trashOutline, pencil, send } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import './speechTextEditModal.scss';

interface SpeechTextEditModalProps {
    isSpeechTextModalVisible: boolean;
    setIsSpeechTextModalVisible: (visible: boolean) => void;
    editedText: string;
    setEditedText: (text: string) => void;
    cancelRecognition: () => void;
    handleTextToInput: () => void;
    handleSend: () => void;
}

const SpeechTextEditModal: React.FC<SpeechTextEditModalProps> = ({
    isSpeechTextModalVisible,
    setIsSpeechTextModalVisible,
    editedText,
    setEditedText,
    cancelRecognition,
    handleTextToInput,
    handleSend
}) => {
    if (!isSpeechTextModalVisible) return null;

    return (
        <div className="speech-modal-wrapper">
            <div className="backdrop" onClick={cancelRecognition}>
                <div className="modal-overlay">
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header-gradient">
                            <h2 className="modal-title">Voice Message</h2>
                            <button className="close-button" onClick={cancelRecognition}>
                                <IonIcon icon={close} style={{ fontSize: '18px' }} />
                            </button>
                        </div>

                        <div className="recognized-label">
                            <IonIcon icon={mic} className="mic-icon" style={{ fontSize: '16px' }} />
                            <span className="recognized-text">Recognized Speech</span>
                        </div>

                        <textarea
                            className="text-input"
                            value={editedText}
                            onChange={(e) => setEditedText(e.target.value)}
                            autoFocus
                            placeholder="Edit your text here..."
                        />

                        <div className="modal-footer">
                            <button className="action-button cancel-button" onClick={cancelRecognition}>
                                <IonIcon icon={trashOutline} style={{ fontSize: '22px' }} />
                            </button>

                            <button className="action-button edit-button" onClick={handleTextToInput}>
                                <IonIcon icon={pencil} style={{ fontSize: '22px' }} />
                            </button>

                            <button className="action-button send-button" onClick={handleSend}>
                                <div className="gradient-background">
                                    <IonIcon icon={send} style={{ fontSize: '22px' }} />
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpeechTextEditModal;